import $ from 'jquery';

import 'bootstrap-datepicker';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker';

import 'eonasdan-bootstrap-datetimepicker/src/js/bootstrap-datetimepicker';
import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker';

export default function(controller) {

  $("[data-toggle='datepicker-default']").datepicker({
    format: 'dd/mm/yyyy'
  });

  $("[data-toggle='datetimepicker-default']").datetimepicker({
    format: 'YYYY/MM/D hh:mm A'
  });

};
